export const checkValidity = (target: HTMLInputElement, invalidMessage: string) => {
  const value = target.value;
  // except dash(-), replace all non alphanumeric characters with an empty string and
  // check if the value is at least 3 characters in length
  const parsedValue = value.replace(/[`~!@#$%^&*()_|+=?;:'",.<>{}[\]\\/\s]/g, '');
  if (parsedValue.length > 2) {
    target.setCustomValidity('');
    target.reportValidity();
  } else {
    target.setCustomValidity(invalidMessage);
  }
};
